export const Prices = [
    {
        _id: 0,
        name: "₹0 to 50",
        array: [0, 50],
    },
    {
        _id: 1,
        name: "₹51 to 100",
        array: [51, 100],
    },
    {
        _id: 2,
        name: "₹101 to 150",
        array: [101, 150],
    },
    {
        _id: 3,
        name: "₹151 to 200",
        array: [151, 200],
    },
    {
        _id: 4,
        name: "₹201 to 500",
        array: [201, 500],
    },
    {
        _id: 5,
        name: "₹501 or more",
        array: [501, 100000],
    },
];